<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4 16C4 9.456 9.71 4 15.568 4a1.2 1.2 0 011.073 1.737 11.123 11.123 0 00-1.063 4.066c-.095 1.722.29 3.503 1.703 4.916 1.413 1.414 3.194 1.798 4.916 1.703 1.742-.097 3.31-.685 4.066-1.063A1.2 1.2 0 0128 16.432C28 22.291 22.543 27.994 16.001 28H16C9.376 28 4 22.624 4 16z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsDarkFilled'
}
</script>
